import { ELocaleCode } from '@core/modules/intl/domain/enums';

export const venueListViewActionsI18n = {
	[ELocaleCode.RU_RU]: {
		create: 'Новое Место',
	},
	[ELocaleCode.EN_US]: {
		create: 'New Venue',
	},
};
